import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import throttle from 'lodash/throttle';

type Props = {
  onScrollCallback?: () => void;
  topMargin?: number;
};

export const ScrollHandler = (props: Props) => {
  const { onScrollCallback, topMargin = 0 } = props;

  const location = useLocation();

  const handleScroll = throttle(() => {
    if (onScrollCallback) onScrollCallback();
  }, 400);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    const element = document.getElementById(location.hash);

    if (!element) return;

    setTimeout(() => {
      window.scrollTo({
        behavior: element ? 'smooth' : 'auto',
        top: getScrollPositionFromElement(element, topMargin),
      });
    }, 100);
  }, [location, topMargin]);

  return null;
};

export function getScrollPositionFromElement(
  element: HTMLElement | null,
  topMargin: number
): number {
  if (!element) {
    return 0;
  }

  const header = window.document.getElementsByTagName('header')?.[0];

  return (
    element.getBoundingClientRect().top +
    window.scrollY -
    topMargin -
    (header?.getBoundingClientRect().height ?? 0)
  );
}
